import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from 'angular-auth-oidc-client';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { groupAuthInterceptor } from './core/interceptors/group-auth.interceptor';
import { FormsModule } from '@angular/forms';
import { SharedUiAngularModule } from '@homepower-co/shared-ui-angular';
import { provideOidcAuth } from './core/auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideOidcAuth(),
    provideHttpClient(
      withInterceptors([
        authInterceptor(),
        groupAuthInterceptor,
        loadingInterceptor,
      ]),
    ),
    importProvidersFrom(SharedUiAngularModule.forRoot(), FormsModule),
  ],
};
